export default __webpack_public_path__ + "static/media/recipeImg.24739195.svg";